import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useAddPaymentProvider } from '../api/addPaymentProvider';
import { Fields } from '../hooks/usePaymentProviderForm';

import { PaymentProviderForm } from './PaymentProviderForm';

type AddModalProps = {
  initialValues: Fields;
};

export const AddModal = NiceModal.create(({ initialValues }: AddModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useAddPaymentProvider({
    department: initialValues.department,
    onSuccess: modal.hide,
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Новый платежный провайдер"
    >
      <PaymentProviderForm
        isLoading={isLoading}
        onSubmit={(params) => mutate({ ...params })}
        initialValues={initialValues}
      />
    </Modal>
  );
});
